import styled from "styled-components/macro";
import { COLORS } from "../../../../layout/theme";
import { Button } from "antd";

export const InnerForm = styled.div`
	display: flex;
	gap: 50px;
	height: 300px;

	/* Inputs dentro de la tabla */
	.ant-input,
	.ant-input-affix-wrapper,
	.ant-input-number,
	.ant-select-selector {
		border-radius: 12px !important;
		border: 1px solid #d1d5db !important;
		box-shadow: none !important;
		min-height: 32px;
	}

	.ant-input {
		padding: 0 12px;
	}

	.ant-input:hover,
	.ant-input-affix-wrapper:hover,
	.ant-input-number:hover,
	.ant-select-selector:hover {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper-focused,
	.ant-input-number-focused,
	.ant-select-focused .ant-select-selector {
		border-color: ${COLORS.DarkGrey} !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	/* Para los Input con addonAfter (% / un.) */
	.ant-input-group-wrapper {
		border-radius: 12px !important;
	}

	.ant-input-group {
		border-radius: 12px !important;
	}

	.ant-input-group .ant-input {
		border-radius: 12px 0 0 12px !important;
	}

	.ant-input-group-addon {
		border-radius: 12px !important;
		border: 1px solid #d1d5db !important;
		border-left: 0 !important;
		background: #f8fafc !important;
		color: #64748b !important;
		font-weight: 600;
		padding: 0 10px;
	}

	/* Para que el focus se vea correcto también en grupos */
	.ant-input-group-wrapper:hover .ant-input,
	.ant-input-group-wrapper:hover .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input-group-wrapper .ant-input:focus + .ant-input-group-addon,
	.ant-input-group-wrapper .ant-input-focused + .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}
`;
export const ProductData = styled.div`
	flex: 1 1 65%;
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
	max-height: 160px;
`;
export const PublishSettings = styled.div`
	flex: 1 1 35%;
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
	max-height: 160px;
`;

export const AntdButton = styled(Button)`
	height: 30px;
`;
